export default __webpack_public_path__ + "static/media/sp_payroll.1730de6c.svg";